export var DateTimeFormat;
(function (DateTimeFormat) {
    // 1 component
    DateTimeFormat["HOUR_NUM"] = "HOUR_NUM";
    DateTimeFormat["MINUTE_NUM"] = "MINUTE_NUM";
    DateTimeFormat["DAY_NUM"] = "DAY_NUM";
    DateTimeFormat["DAY_TEXT"] = "DAY_TEXT";
    DateTimeFormat["MONTH_NUM"] = "MONTH_NUM";
    DateTimeFormat["MONTH_TEXT"] = "MONTH_TEXT";
    DateTimeFormat["MONTH_SHORT_TEXT"] = "MONTH_SHORT_TEXT";
    DateTimeFormat["WEEKDAY_TEXT"] = "WEEKDAY_TEXT";
    DateTimeFormat["WEEKDAY_SHORT_TEXT"] = "WEEKDAY_SHORT_TEXT";
    DateTimeFormat["YEAR_NUM"] = "YEAR_NUM";
    DateTimeFormat["YEAR_SHORT_NUM"] = "YEAR_SHORT_NUM";
    // 2 components
    DateTimeFormat["TIME_NUM"] = "TIME_NUM";
    DateTimeFormat["DAY_MONTH_NUM"] = "DAY_MONTH_NUM";
    DateTimeFormat["DAY_MONTH_TEXT"] = "DAY_MONTH_TEXT";
    DateTimeFormat["DAY_MONTH_SHORT_TEXT"] = "DAY_MONTH_SHORT_TEXT";
    DateTimeFormat["WEEKDAY_DAY_TEXT"] = "WEEKDAY_DAY_TEXT";
    DateTimeFormat["WEEKDAY_DAY_SHORT_TEXT"] = "WEEKDAY_DAY_SHORT_TEXT";
    DateTimeFormat["MONTH_YEAR_TEXT"] = "MONTH_YEAR_TEXT";
    DateTimeFormat["MONTH_YEAR_SHORT_TEXT"] = "MONTH_YEAR_SHORT_TEXT";
    // 3 components
    DateTimeFormat["WEEKDAY_DAY_MONTH_TEXT"] = "WEEKDAY_DAY_MONTH_TEXT";
    DateTimeFormat["WEEKDAY_DAY_MONTH_SHORT_TEXT"] = "WEEKDAY_DAY_MONTH_SHORT_TEXT";
    DateTimeFormat["DATE_NUM"] = "DATE_NUM";
    DateTimeFormat["DATE_TEXT"] = "DATE_TEXT";
    DateTimeFormat["DATE_SHORT_TEXT"] = "DATE_SHORT_TEXT";
    // 4 components
    DateTimeFormat["WEEKDAY_DATE_TEXT"] = "WEEKDAY_DATE_TEXT";
    DateTimeFormat["WEEKDAY_DATE_SHORT_TEXT"] = "WEEKDAY_DATE_SHORT_TEXT";
    // 5 components
    DateTimeFormat["DATE_TIME_NUM"] = "DATE_TIME_NUM";
    DateTimeFormat["DATE_TIME_TEXT"] = "DATE_TIME_TEXT";
    DateTimeFormat["DATE_TIME_SHORT_TEXT"] = "DATE_TIME_SHORT_TEXT";
    // 6 components
    DateTimeFormat["WEEKDAY_DATE_TIME_TEXT"] = "WEEKDAY_DATE_TIME_TEXT";
    DateTimeFormat["WEEKDAY_DATE_TIME_SHORT_TEXT"] = "WEEKDAY_DATE_TIME_SHORT_TEXT";
})(DateTimeFormat || (DateTimeFormat = {}));
